const INITIAL_STATE = {
  formulas: [],
  pagination: {
    page: 1,
    itemsPerPage: 15,
    totalItems: 0
  },
  search: {
    ref: '',
    startsWith: false
  }
}

export default function formulaListReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'FORMULA_LIST_FETCH_FORMULAS':
      return {
        ...state,
        formulas: action.payload
      }
    case 'FORMULA_LIST_SET_PAGE':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          page: action.payload
        }
      }
    case 'FORMULA_LIST_SET_ITEMS_PER_PAGE':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          itemsPerPage: action.payload
        }
      }
    case 'FORMULA_LIST_SET_TOTAL_ITEMS':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          totalItems: action.payload
        }
      }
    case 'FORMULA_LIST_SET_REF':
      return {
        ...state,
        search: {
          ...state.search,
          ref: action.payload
        }
      }
    case 'FORMULA_LIST_SET_STARTS_WITH':
      return {
        ...state,
        search: {
          ...state.search,
          startsWith: action.payload
        }
      }
    case 'FORMULA_LIST_CLEAR_SEARCH':
      return {
        ...state,
        search: {
          ...INITIAL_STATE.search
        }
      }
    case 'FORMULA_LIST_CLEAR_PAGINATION':
      return {
        ...state,
        pagination: {
          ...INITIAL_STATE.pagination
        }
      }
    case 'FORMULA_LIST_CLEAR_FORMULAS':
      return {
        ...state,
        ...INITIAL_STATE
      }
    default:
      return state
  }
}
